import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';

export type ProviderInput = NonNullable<TrpcInputs['getProvider']>;
export type ProviderOutput = TrpcOutputs['getProvider'];
type UseProvider = [ProviderOutput | undefined, boolean, any | undefined];

export const useProvider = (id: string): UseProvider => {
  const { data, isLoading, error } = trpc.getProvider.useQuery({ id }, { refetchOnWindowFocus: false });

  return [data, isLoading, error];
};
